import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { SchoolProfile, SchoolProfileGroupType } from '@modules/types/graphql';
import { SchoolProfileGroupEntityList } from './school-profile-group.entity-list';
import { SchoolProfileGroupEntity } from './school-profile-group.entity';

export type Entity = SchoolProfile | null;

@DecribeEntity('SchoolProfileEntity')
class SchoolProfileEntity extends BaseEntity {
    id: string;
    shortName: string;
    fullName: string;

    @RelationList(() => SchoolProfileGroupEntityList)
    groups: SchoolProfileGroupEntity[];

    constructor(school: Entity) {
        super(school);

        this.id = school?.id ?? '';
        this.shortName = school?.shortName ?? '';
        this.fullName = school?.fullName ?? '';
    }

    getSummaryGroup() {
        const result = this.groups.find(group => group.type === SchoolProfileGroupType.summary);

        if (!result) {
            return new SchoolProfileGroupEntity({});
        }

        return result;
    }

    getRequisitesGroup() {
        const result = this.groups.find(group => group.type === SchoolProfileGroupType.requisites);

        if (!result) {
            return new SchoolProfileGroupEntity({});
        }

        return result;
    }
}

export { SchoolProfileEntity };
